import { useEffect } from "react";
import Lenis from "lenis";

/** Mounts Lenis for smooth momentum scrolling across the whole app. */
export default function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      lerp: 0.08,
    });

    // Hook into anchor clicks for scrollTo-based nav
    const onAnchor = (e) => {
      const target = e.target.closest("[data-lenis-scroll]");
      if (!target) return;
      const sel = target.getAttribute("data-lenis-scroll");
      const el = document.querySelector(sel);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -80, duration: 1.2 });
    };
    document.addEventListener("click", onAnchor);

    // Expose a tiny API for programmatic scrolling (used by Navigation)
    window.__lenis = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return null;
}
